/* @flow */

import React from 'react';
import styled from 'styled-components';

import withI18n from '../../../utils/withI18n';
import FlexBox from '../../FlexBox';

import Banner from './banner';
import Lists from './lists';

const WrapperBox = styled(FlexBox)`
  width: 100%;
  a:hover {
    color: rgba(240, 185, 11, 1) !important;
  }
`;

type Props = {
  locale: string,
  i18n: Object,
};

export default
@withI18n
class Ecosystem extends React.Component<Props> {
  static defaultProps = {
    locale: 'en',
    i18n: {},
  };

  render() {
    return (
      <WrapperBox>
        <Banner />
        <Lists />
      </WrapperBox>
    );
  }
}
